import { ChangeEventHandler, KeyboardEventHandler } from 'react';
import './TextArea.css';

type TextAreaProps = {
	className?: string;
	placeholder: string;
	value?: string;
	onChange?: ChangeEventHandler<HTMLTextAreaElement>;
	onBlur?: ChangeEventHandler<HTMLTextAreaElement>;
	autoFocus?: boolean;
	onKeyDown?: KeyboardEventHandler<HTMLTextAreaElement>;
	nextElement?: string;
	name?: string;
};

export const TextArea = ({
	name,
	className = '',
	placeholder,
	value,
	onChange,
	onBlur,
	autoFocus,
	onKeyDown,
	nextElement,
}: TextAreaProps): JSX.Element => {
	return (
		<textarea
			className={`textarea ${className}`}
			placeholder={placeholder}
			value={value}
			onChange={onChange}
			onBlur={onBlur}
			autoFocus={autoFocus}
			onKeyDown={onKeyDown}
			name={name}
			data-nextelement={nextElement}
		/>
	);
};
